/**
 * Adapptio Core Library
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericIntegrationDefinition } from "../integrations";

export interface IIntegrationDefRegistry extends ItemRegistry<TGenericIntegrationDefinition> {}
export class IntegrationDefRegistry extends ItemRegistry<TGenericIntegrationDefinition> {}
